"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureCompletedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AdventureCompletedEventArgs {
    constructor(adventureId) {
        this.adventureId = adventureId;
        this.__type = EventType_1.EventType.AdventureCompleted;
        this.__typeName = "AdventureCompleted";
    }
}
exports.AdventureCompletedEventArgs = AdventureCompletedEventArgs;
